import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import InfoStatusIcon from "./InfoStatusIcon";
import { InfoStatusTypesPropTypes, InfoStatusPositionsPropTypes } from "./InfoStatusPropTypes";
const InfoStatus = ({ className, position, text, type, wrap }) => {
    const buildClassname = `gerudo-info-status ${type ? type : ""}${position && " " + position}`;
    const classes = classNames(buildClassname, "gerudo-info-status", className, { wrap });
    return (React.createElement("div", { className: classes },
        React.createElement(InfoStatusIcon, { type: type }),
        " ",
        text));
};
InfoStatus.defaultProps = {
    type: "submitted",
    position: "left",
};
InfoStatus.propTypes = {
    type: InfoStatusTypesPropTypes,
    text: PropTypes.string.isRequired,
    position: InfoStatusPositionsPropTypes,
    wrap: PropTypes.bool,
};
export default InfoStatus;
export { InfoStatus };
export * from "./InfoStatusPropTypes";
//# sourceMappingURL=index.js.map